import * as React from 'react';

import * as style from './styles.css';

export interface IFooterProps {
  like: React.ReactNode;
  dislike: React.ReactNode;
  answer: React.ReactNode;
  answerVisibility?: React.ReactNode;
}

export const Footer: React.FC<IFooterProps> = ({ like, dislike, answer, answerVisibility }) => {
  const showLeft = !!like && !!dislike;
  const showRight = !!answer || !!answerVisibility;

  return (
    <div data-testid="Footer" className={style['container']}>
      {showLeft && (
        <div className={style['left']}>
          <div className={style['like']}>{like}</div>
          <div className={style['dislike']}>{dislike}</div>
        </div>
      )}
      {showRight && (
        <div className={style['right']}>
          {!!answer && <div className={style['answer']}>{answer}</div>}
          {!!answerVisibility && <div className={style['answer_visbility']}>{answerVisibility}</div>}
        </div>
      )}
    </div>
  );
};
